<template lang="">
  <div class="q-pa-md">
    <q-card class="my-card" flat bordered>
      <q-item>
        <q-item-section avatar>
          <q-icon name="shopping_cart" />
        </q-item-section>
        <q-item-section>
          <q-item-label>Paketler</q-item-label>
        </q-item-section>
      </q-item>
      <q-separator />
      <q-card-section horizontal>
        <q-card-section>
          <CreateSubscription />
        </q-card-section>
        <q-separator vertical />
        <q-card-section class="col-4">
          Bu sayfadan sistemde tanimli abonelik paketlerini yonetebilirsiniz.
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>
  <div class="q-pa-md">
    <SubscriptionsTable :subscriptions="subscriptions" />
  </div>
</template>
<script>
import axios from 'axios'
import { ref, inject } from 'vue'
import CreateSubscription from '../components/subscription/Create.vue'
import SubscriptionsTable from '../components/subscription/Table.vue'
import * as eventNames from '../utils/events'

export default {
  components: {
    CreateSubscription,
    SubscriptionsTable,
  },
  setup() {
    const emitter = inject('emitter')
    emitter.on(eventNames.REFRESH_SUBSCRIPTIONS, () => {
      fetchAllSubscriptions()
    })

    const subscriptions = ref([])

    // Fetch Data Feature
    const fetchAllSubscriptions = () => {
      return axios.get('/subscriptions').then((response) => {
        subscriptions.value = response.data
      })
    }

    return {
      subscriptions,
      fetchAllSubscriptions,
    }
  },
  created() {
    this.fetchAllSubscriptions()
  },
}
</script>
